import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TextareaModule } from 'primeng/textarea';

import { LandingText } from '../landing.types';
import { RevealOnScrollDirective } from './reveal-on-scroll.directive';

@Component({
    selector: 'app-landing-contact',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, InputTextModule, TextareaModule, ButtonModule, RevealOnScrollDirective],
    templateUrl: './landing-contact.component.html',
    styleUrl: './landing-contact.component.scss'
})
export class LandingContact {
    readonly text = input.required<LandingText>();
    readonly contactBenefitIcons = input.required<string[]>();
    readonly demoForm = input.required<FormGroup>();
    readonly demoSubmitted = input.required<boolean>();

    readonly submitDemo = output<void>();

    // Honeycomb backdrop: each hexagon's blink delay is staggered by its row+column so the pulse ripples diagonally.
    private static readonly HEX_ROWS = 5;
    private static readonly HEX_COLS = 8;
    readonly hexRows = Array.from({ length: LandingContact.HEX_ROWS }, (_, row) => ({
        offset: row % 2 === 1,
        cells: Array.from({ length: LandingContact.HEX_COLS }, (_, col) => ({
            delay: ((row + col) % 6) * 0.35
        }))
    }));
}
